// extracted by mini-css-extract-plugin
export var active = "_3c-9";
export var backButton = "_3c-8";
export var clone = "_3c-e";
export var collapseBar = "_3c-j";
export var collapseMode = "_3c-l";
export var collapsed = "_3c-n";
export var dragHandle = "_3c-c";
export var dropdownIcon = "_3c-g";
export var expanding = "_3c-m";
export var hidden = "_3c-w";
export var iconContainer = "_3c-p";
export var iconSwapper = "_3c-v";
export var navItem = "_3c-6";
export var navItemIcon = "_3c-f";
export var navProfile = "_3c-7";
export var notificationCountBadge = "_3c-i";
export var notificationDot = "_3c-q";
export var optionsContainer = "_3c-h";
export var primaryNav = "_3c-0";
export var primaryNavDivider = "_3c-u";
export var primaryNavResizeHandle = "_3c-2";
export var primaryNavResizing = "_3c-1";
export var primaryNavTabSection = "_3c-t";
export var primaryTab = "_3c-o";
export var primaryTabIconBox = "_3c-r";
export var secondaryNav = "_3c-3";
export var selected = "_3c-s";
export var settingsNav = "_3c-4";
export var settingsNavItems = "_3c-5";
export var show = "_3c-d";
export var sideNav = "_3c-k";
export var teamItem = "_3c-a";
export var userProfileItem = "_3c-b";